import router from './router'
import store from './store'

const whtieList = ['/login']

router.beforeEach(async (to, from, next) => {
  const hasToken = store.getters.hasToken
  if (hasToken) {
    if (to.path === '/login') {
      next({ name: 'home' })
    } else {
      next()
    }
  } else {
    if (whtieList.indexOf(to.path) > -1) {
      next()
    } else {
      next({ name: 'login' })
    }
  }
})